import { Box, Flex, Stack, useToast } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { AxiosRequestConfig } from 'axios';
import { Button, ColorfulBar, Heading, Input } from '~/components';
import {
  EmailControls,
  EmailsConfiguration,
} from '~/pages/Portal/Settings/EmailControls';
import api from '~/utils/api';
import { queryClient } from '~/utils/react-query';

export const Emails: React.VFC = () => {
  const [isFetching, setFetching] = useState(false);
  const toast = useToast();

  const saveForm = (form: EmailsConfiguration) => {
    setFetching(true);

    const config: AxiosRequestConfig = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const request = api.post(`/configuracao_email`, form, config);
    request
      .then(() => {
        queryClient.invalidateQueries('emailConfiguration');
        toast({
          title: 'Configuração de e-mail alterado',
          status: 'success',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      })
      .catch(error => {
        if (error.response.status === 403) {
          toast({
            title: 'Usuário sem permissão',
            description: 'Sem permissão para execução da operação.',
            status: 'error',
            duration: 3000,
            isClosable: true,
            position: 'top-right',
          });
        } else if (error.response.status === 400) {
          const errorsValidate = Object.entries(error.response.data);
          errorsValidate.forEach(err => {
            // console.log(err[0]);
            toast({
              title: `Erros ao editar configuração de e-mail`,
              description: String(err[1]),
              status: 'error',
              duration: 3000,
              isClosable: true,
              position: 'top-right',
            });
          });
        } else {
          toast({
            title: `Erro ao editar configuração de e-mail`,
            description: 'Tente novamente',
            status: 'error',
            duration: 3000,
            isClosable: true,
            position: 'top-right',
          });
        }
      })
      .finally(() => {
        setFetching(false);
      });
  };

  return (
    <>
      <Box px="8" py="4">
        <Heading>Configurações de e-mail</Heading>
        <Flex flexDir="row" flexWrap="wrap" w="100%" py={9} gridGap="6">
          <Stack gridGap={4} width="40%" as="form">
            <EmailControls
              title="Extensão de contratos"
              saveForm={saveForm}
              tipoConfiguracao={1}
            />
          </Stack>
          {/* <Stack gridGap={4} width="40%" as="form"> */}
          {/*  <EmailControls */}
          {/*    title="Instruções de devolução e coleta para o Cliente" */}
          {/*    saveForm={saveForm} */}
          {/*    tipoConfiguracao={2} */}
          {/*  /> */}
          {/* </Stack> */}
        </Flex>
        {/* <Flex flexDir="row" flexWrap="wrap" w="100%" gridGap="5"> */}
        {/*  <Stack gridGap={4} width="40%" as="form"> */}
        {/*    <EmailControls */}
        {/*      title="Agendamentos de Coleta de equipamentos" */}
        {/*      saveForm={saveForm} */}
        {/*      tipoConfiguracao={3} */}
        {/*    /> */}
        {/*  </Stack> */}
        {/* </Flex> */}
      </Box>
    </>
  );
};
